import { useTranslation } from "react-i18next";

type Outcome = "WON" | "LOST" | null;

type Props = {
  outcome?: string | null;
  disabled?: boolean;
  onSetOutcome: (outcome: Outcome) => void | Promise<void>;
};

export default function ProjectOutcomeButtons({
  outcome,
  disabled,
  onSetOutcome,
}: Props) {
  const { t } = useTranslation();
  const isWon = outcome === "WON";
  const isLost = outcome === "LOST";

  const handleWon = () => {
    if (disabled) return;
    onSetOutcome(isWon ? null : "WON");
  };

  const handleLost = () => {
    if (disabled) return;
    onSetOutcome(isLost ? null : "LOST");
  };

  return (
    <div className="flex items-center gap-1.5 max-md:grid max-md:w-full max-md:grid-cols-2 max-md:gap-2">
      <button
        type="button"
        disabled={disabled}
        onClick={handleWon}
        className={
          "rounded-md px-3 py-1.5 text-sm font-semibold transition-colors disabled:opacity-50 max-md:min-h-11 " +
          (isWon
            ? "bg-emerald-600 text-white shadow-sm hover:bg-emerald-500"
            : "border border-emerald-600/60 bg-white text-emerald-700 hover:bg-emerald-50 dark:bg-[var(--p-color-bg-surface)] dark:hover:bg-emerald-950/30")
        }
      >
        {t("project_outcome_won", { defaultValue: "Won" })}
      </button>
      <button
        type="button"
        disabled={disabled}
        onClick={handleLost}
        className={
          "rounded-md px-3 py-1.5 text-sm font-semibold transition-colors disabled:opacity-50 max-md:min-h-11 " +
          (isLost
            ? "bg-red-600 text-white shadow-sm hover:bg-red-500"
            : "border border-red-500/60 bg-white text-red-700 hover:bg-red-50 dark:bg-[var(--p-color-bg-surface)] dark:hover:bg-red-950/30")
        }
      >
        {t("project_outcome_lost", { defaultValue: "Lost" })}
      </button>
    </div>
  );
}
